export const fetchWithTimeout = (timeout = 2000) => (url, rest) => {
  try {
    const controller = new AbortController();
    const signal = controller.signal;

    return Promise.race([
      fetch(url, {
        credentials: 'same-origin',
        signal,
        ...rest
      }),
      new Promise((_, reject) =>
        setTimeout(() => {
          controller.abort();
          return reject(`fetch timeout for ${url} after ${timeout}ms`);
        }, timeout)
      )
    ]);
  } catch (error) {
    return Promise.reject(error);
  }
};
